<template>
  <v-table
    class="v-table-header-line-full"
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorOnboardApplyList.push"
    :query-list="queryList"
    :is-show-search-input="true"
    search-placeholder="输入昵称/用户名/手机号"
  >
    <template slot="header-item">
      <v-select-store
        class="table-filter-item table-filter-select"
        v-model="queryList.store_id"
        :has-private="true"
        :clearable="true"
        size="small"
        placeholder="门店"
        @input="handleStoreChange"
      />
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        :clearable="true"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </template>

    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="昵称" prop="nickname" width="120"/>
    <el-table-column label="用户名" prop="username" width="130"/>
    <el-table-column label="手机号" prop="phone" width="130"/>
    <el-table-column label="门店" width="160">
      <template v-slot="{ row }">{{ row.store_name | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="职位" prop="role_name" width="130"/>
    <el-table-column label="状态" width="100">
      <template v-slot="{ row }">
        <el-tag :type="applyStateTag(row.apply_state)">{{ applyStateName(row.apply_state) }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="提交时间" width="160">
      <template v-slot="{ row }">{{ row.add_time | timeToYmdHi }}</template>
    </el-table-column>
    <el-table-column label="操作" width="140">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="view" :to="RouteConfig.administratorOnboardApplyDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`onboard-apply-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>昵称</span>
              <span>{{ v.nickname }}</span>
            </div>
            <div class="list-item-detail">
              <span>用户名</span>
              <span>{{ v.username }}</span>
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>门店</span>
              <span>{{ v.store_name | formatStoreName }}</span>
            </div>
            <div class="list-item-detail">
              <span>职位</span>
              <span>{{ v.role_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>状态</span>
              <el-tag :type="applyStateTag(v.apply_state)">{{ applyStateName(v.apply_state) }}</el-tag>
            </div>
            <div class="list-item-button">
              <v-list-button name="查看" icon="view" :to="RouteConfig.administratorOnboardApplyDetail.to(v.id)"/>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import { applyStates } from '@/enums/applyStates';
import RouteConfig from '@/router/config';
import { onboardApplyIndex } from '@/api/personnel';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.administratorOnboardApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    isLoading: false,
    queryList: {
      is_asc: 0,
      store_id: 0,
      apply_state: applyStates.review.value,
      keyword: '',
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.administratorOnboardApplyList.push(this.queryList);
    },
    applyStateName(value) {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(value)) return applyStates[key].name;
      }
      return '';
    },
    applyStateTag(value) {
      for (const key in applyStates) {
        if (Number(applyStates[key].value) === Number(value)) return applyStates[key].tagType || 'info';
      }
      return 'info';
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await onboardApplyIndex(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list || [];
      if (next) next();
    },
    goDetail(id) {
      RouteConfig.administratorOnboardApplyDetail.push(id);
    },
  },
};
</script>



